import * as React from 'react'
import './style.less'
import {Surface} from 'telstra-ui/components/surface/Surface'
import {SurfaceList} from 'telstra-ui/components/list/List'
import {SvgIcon} from 'telstra-ui/components/svg/Icon'
import {
  getTileName,
  getTileNameInt,
  getTileNameYPandSInt,
} from '@telstra-connect/utils/helper/get-tile-name'
import {connect} from 'react-redux'
import {IAuthorizedRequestState} from '@telstra-connect/utils/http/requests/request'
import {
  getCompanyId,
  isInternationalWorkFlow,
  isInternationalCustomer,
} from '@telstra-connect/config/config'

interface INPCardSurfaceErrorBoundaryState {
  hasError: boolean
}

interface IStateProps {
  authorizedRequestState: IAuthorizedRequestState
}

interface IStateOwnProps {
  children?: React.ReactNode
  yourProductAndServices?: boolean
}

export class NPCardSurfaceErrorBoundaryComp extends React.Component<
  IStateOwnProps & IStateProps,
  INPCardSurfaceErrorBoundaryState
> {
  constructor(props) {
    super(props)
    this.state = {hasError: false}
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return {hasError: true}
  }

  private handleErrorCallback = () => window.location.reload()

  private renderErrorHeader = () => {
    const companyId = getCompanyId(
      this.props.authorizedRequestState.tokens,
      this.props.authorizedRequestState.user,
      this.props.authorizedRequestState.userManagement,
    )
    const isInternationalUser = isInternationalCustomer(companyId)

    return (
      <div
        className="tl-heading__container"
        style={{cursor: 'initial'}}
        id="ui-np-card-error-heading"
      >
        <div className="__heading">
          {isInternationalWorkFlow(isInternationalUser)
            ? this.props.yourProductAndServices
              ? getTileNameYPandSInt()
              : getTileNameInt()
            : getTileName()}
        </div>
      </div>
    )
  }

  private renderErrorBody = (
    <div className="tc-np-card-error">
      <div className="tc-np-card-error__body">
        <SvgIcon
          name={'picto-empty-state'}
          className="tc-telstra-icon tc-np-card-error__body__icon"
        />
        <div className="tc-np-card-error__body__icon__error" id="ui-np-card-error-text">
          {'Loading error'}
        </div>
        <div className="tc-np-card-error__body__icon__text" id="ui-np-card-error-subtext">
          There was an error loading this app.
        </div>
      </div>
    </div>
  )

  private renderErrorFooter = (
    <div
      id="ui-np-card-refresh"
      className="tc-np-card-error__button tl-list-im-button"
      onClick={this.handleErrorCallback}
    >
      <SvgIcon
        name={'icon-system-refresh'}
        className="tc-footer-refresh-icon"
        id="ui-np-card-refresh-icon"
      />
      <span className="tc-footer-text" id="ui-np-card-refresh-text">
        Refresh
      </span>
    </div>
  )

  render() {
    if (this.state.hasError) {
      return (
        <div className="tc-np-surface-container" style={{height: '424px'}}>
          <Surface
            className="tl-custom-width tl-surface-dashboard ui-card-error"
            name="surface-flat"
            id="ui-np-card"
          >
            <div className="tl-card-inner-content">
              <SurfaceList
                header={this.renderErrorHeader()}
                body={<>{this.renderErrorBody}</>}
                footer={this.renderErrorFooter}
              />
            </div>
          </Surface>
        </div>
      )
    }

    return this.props.children
  }
}

type IAppState = IAuthorizedRequestState & INPCardSurfaceErrorBoundaryState

const mapStateToProps = (state: IAppState): IStateProps => {
  const {user, router, tokens, userManagement} = state
  return {
    authorizedRequestState: {
      user,
      router,
      tokens,
      userManagement,
    },
  }
}

const NPCardSurfaceErrorBoundary = connect<IStateProps, {}, IStateOwnProps, IAppState>(
  mapStateToProps,
)(NPCardSurfaceErrorBoundaryComp)

export default NPCardSurfaceErrorBoundary
